import { useEffect, useState } from 'react';

const UseForm = (formObj, validate, callback) => {
  const [values, setValues] = useState(formObj);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));

  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setErrors(validate(values));
    setIsSubmitting(true);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    setValues((prev) => ({
      ...prev,
      [name]: value.trim(), // Trim only on blur
    }));
  };

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
      setIsSubmitting(false)
    }
  }, [errors, isSubmitting]); // ✅ Added `callback` to dependencies

  return {
    handleChange,
    handleSubmit,
    handleBlur,
    values,
    errors,
    setValues,
    setErrors,
  };
};

export default UseForm;
